angular.module('unergie.main')
.filter('invoiceType', () => {
    return (value) => {
        switch (value) {
            case 'MISC':
                return 'Frais'
            case 'MISC_REVERSAL':
                return 'Annulation Frais'
            case 'REG':
                return 'Régularisation'
            case 'REG_REVERSAL':
                return 'Annulation facture'
            case 'REG_FINAL':
                return 'Facture de résiliation'
            case 'REG_FINAL_REVERSAL':
                return 'Annulation facture de résil.'
            default:
                return value
        }
    }
})
